<script setup lang="ts">
import { storeToRefs } from "pinia";
import { useEditTransaction } from "@/components/EditTransaction/state.ts";

const state = useEditTransaction();

const { description } = storeToRefs(state);
</script>

<template>
  <div class="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
    <label class="block text-sm/6 font-medium text-gray-900" for="amount">Omschrijving</label>
    <div class="sm:col-span-2">
      <div
        class="flex items-center rounded-md bg-white pl-3 outline -outline-offset-1 outline-gray-300 focus-within:outline focus-within:-outline-offset-2 focus-within:outline-indigo-600 sm:max-w-md"
      >
        <div class="shrink-0 select-none text-base text-gray-500 sm:text-sm/6"></div>
        <textarea
          id="comment"
          v-model="description"
          class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-0 placeholder:text-gray-400 sm:text-sm/6"
          name="comment"
          rows="4"
        />
      </div>
    </div>
  </div>
</template>
